var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphoneIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 10.125H2.8125C2.50184 10.125 2.25 10.3768 2.25 10.6875V16.3125C2.25 16.6232 2.50184 16.875 2.8125 16.875H7.3125C7.62316 16.875 7.875 16.6232 7.875 16.3125V10.6875C7.875 10.3768 7.62316 10.125 7.3125 10.125Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.6875L21.375 4.5V22.5L7.875 16.3125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 22.5C23.1801 22.5 24.1875 18.4706 24.1875 13.5C24.1875 8.52944 23.1801 4.5 21.9375 4.5C20.6949 4.5 19.6875 8.52944 19.6875 13.5C19.6875 18.4706 20.6949 22.5 21.9375 22.5Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.875V21.9375C4.5 23.0625 5.0625 23.625 6.1875 23.625H7.3125C8.4375 23.625 9 23.0625 9 21.9375V16.875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneIcon);
export default __webpack_public_path__ + "static/media/MegaphoneIcon.3fc462f5.svg";
export { ForwardRef as ReactComponent };